let audioCtx;

// Bell Sound Parameters
const BELL_SOUND_LOCK = 'bell_sound_lock';
const BELL_FUNDAMENTAL_FREQ_HZ = 880;
const BELL_PARTIAL_RATIO = 2.76;
const BELL_STRIKE_FREQ_HZ = 2400;

const BELL_PEAK_GAIN = 0.10;
const BELL_SILENCE_GAIN = 0.0001;
const BELL_DURATION_SEC = 3;

async function initAudioContext() {
    if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    if (audioCtx.state === 'suspended') await audioCtx.resume();
}

function playBellSound() {
    const now = audioCtx.currentTime;

    // Master gain node for overall sound envelope
    const masterGain = audioCtx.createGain();
    masterGain.gain.setValueAtTime(0, now);
    masterGain.gain.linearRampToValueAtTime(BELL_PEAK_GAIN, now + 0.005);
    masterGain.gain.exponentialRampToValueAtTime(BELL_SILENCE_GAIN, now + BELL_DURATION_SEC);
    masterGain.connect(audioCtx.destination);

    // 1. Fundamental Tone (Sine wave - body of the bell)
    const fundOsc = audioCtx.createOscillator();
    fundOsc.type = 'sine';
    fundOsc.frequency.setValueAtTime(BELL_FUNDAMENTAL_FREQ_HZ, now);
    fundOsc.connect(masterGain);

    // 2. Inharmonic Overtone (Triangle wave - bright metallic chime)
    const overtoneOsc = audioCtx.createOscillator();
    const overtoneGain = audioCtx.createGain();
    overtoneOsc.type = 'triangle';
    overtoneOsc.frequency.setValueAtTime(BELL_FUNDAMENTAL_FREQ_HZ * BELL_PARTIAL_RATIO, now);

    // The overtone decays faster than the fundamental frequency
    overtoneGain.gain.setValueAtTime(0.6, now);
    overtoneGain.gain.exponentialRampToValueAtTime(BELL_SILENCE_GAIN, now + (BELL_DURATION_SEC * 0.5));

    overtoneOsc.connect(overtoneGain);
    overtoneGain.connect(masterGain);

    // 3. Impact Transient ("Clapper Strike" click sound)
    const strikeOsc = audioCtx.createOscillator();
    const strikeGain = audioCtx.createGain();
    strikeOsc.type = 'sine';
    strikeOsc.frequency.setValueAtTime(BELL_STRIKE_FREQ_HZ, now);
    strikeOsc.frequency.exponentialRampToValueAtTime(BELL_FUNDAMENTAL_FREQ_HZ, now + 0.015);

    strikeGain.gain.setValueAtTime(0.4, now);
    strikeGain.gain.exponentialRampToValueAtTime(BELL_SILENCE_GAIN, now + 0.02);

    strikeOsc.connect(strikeGain);
    strikeGain.connect(masterGain);

    // Start all nodes simultaneously
    fundOsc.start(now);
    overtoneOsc.start(now);
    strikeOsc.start(now);

    // Stop nodes after decay finishes
    fundOsc.stop(now + BELL_DURATION_SEC);
    overtoneOsc.stop(now + BELL_DURATION_SEC * 0.5);
    strikeOsc.stop(now + 0.02);
}

function lockAndPlayBellSound() {
    if (!audioCtx || audioCtx.state !== 'running') return;

    const { locks } = navigator ?? {};
    if (locks) {
        // Request a lock to ensure only one bell sound plays at a time
        locks.request(BELL_SOUND_LOCK, { ifAvailable: true }, async (lock) => {
            if (!lock) return; // Exit if the lock is not available

            // Execute the bell sound while holding the lock
            playBellSound();

            // Wait for the duration of the sound before releasing lock
            await new Promise((resolve) => setTimeout(resolve, BELL_DURATION_SEC * 1000));
        });
    }
}

export { initAudioContext, lockAndPlayBellSound };
